<template>
  <div>
    <el-row>
      <el-col>
        <el-button
          type="primary"
          size="small"
          @click.native="downloadCSV()"
        >
          Generate Report
        </el-button>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Imported Note-Reconciled"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
    />
  </div>
</template>

<script>
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    Preview
  },
  data () {
    return {
      breadcrumb: {
        name: 'Imported Note-Reconciled',
        route: { name: 'reports-invoice-carrier' }
      },
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    async downloadCSV () {
      this.configuration = {
        report: 'ImportedNotReconciled',
        params: {}
      }
      this.isShowPreview = true
    }
  }
}
</script>
